






    Date.prototype.format = function() {
 　　　　　var s = '';
　　　　　var mouth = (this.getMonth() + 1)>=10?(this.getMonth() + 1):('0'+(this.getMonth() + 1));
　　　　　var day = this.getDate()>=10?this.getDate():('0'+this.getDate());
　　　　　s += this.getFullYear() + '-'; // 获取年份。
　　　　　s += mouth + "-"; // 获取月份。
　　　　　s += day; // 获取日。
　　　　　return (s); // 返回日期。
　　};
		 
　　function getAll(begin:any, end:any) {
　　　　var arr = [];
　　　　var ab = begin.split("-");
　　　　var ae = end.split("-");
　　　　var db = new Date();
　　　　db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
　　　　var de = new Date();
　　　　de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
　　　　var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
　　　　var unixDe = de.getTime() - 24 * 60 * 60 * 1000;
　　　　for (var k = unixDb; k <= unixDe;) {
    　　　　　　//console.log((new Date(parseInt(k))).format());
    　　　　　　k = k + 24 * 60 * 60 * 1000;
    　　　　　　arr.push([(new Date(parseInt(k))).format(),Math.round(Math.random()*100)]);
　　　　}
　　　　return arr;
    }
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import echarts from 'echarts'
    @Component
    export default class HelloWorld extends Vue {
        options:any = {}
        //当前年
        mounted() {
            let myChart = echarts.init(document.getElementById('myChart'))
            let data = getAll('2019-01-01','2019-12-31');
            var unit = 10;
            myChart.setOption({
                backgroundColor: '#404a59',
                title: {
                    top: 10,
                    text: '用药记录',
                    subtext: '数据纯属虚构',
                    left: 'center',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        return params.data+ 'hr';
                    }
                },
                legend: {
                    top: '70',
                    left: 'center',
                    data: ['TimeLog', 'Top 12'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                calendar: [{
                    top: 140,
                    left: 'center',
                    range: ['2019-01-01', '2019-06-30'],
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#000',
                            width: 4,
                            type: 'solid'
                        }
                    },
                    yearLabel: {
                        formatter: '{start} 上半年',
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    monthLabel:{
                        nameMap: 'cn'
                    },
                    dayLabel:{
                        nameMap: "cn",
                        firstDay: 1
                    },
                    itemStyle: {
                        normal: {
                            color: '#323c48',
                            borderWidth: 1,
                            borderColor: '#111'
                        }
                    }
                }, {
                    top: 340,
                    left: 'center',
                    range: ['2019-07-01', '2019-12-31'],
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#000',
                            width: 4,
                            type: 'solid'
                        }
                    },
                    yearLabel: {
                        formatter: '{start} 下半年',
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    monthLabel:{
                        nameMap: 'cn'
                    },
                    dayLabel:{
                        nameMap: "cn",
                        firstDay: 1
                    },
                    itemStyle: {
                        normal: {
                            color: '#323c48',
                            borderWidth: 1,
                            borderColor: '#111'
                        }
                    }
                }],
                series: [{
                        name: 'TimeLog',
                        type: 'scatter',
                        coordinateSystem: 'calendar',
                        data: data,
                        symbolSize: function(val) {
                            return val[1] / unit;
                        },
                        itemStyle: {
                            normal: {
                                color: '#ddb926'
                            }
                        }
                    },
                    {
                        name: 'TimeLog',
                        type: 'scatter',
                        coordinateSystem: 'calendar',
                        calendarIndex: 1,
                        data: data,
                        symbolSize: function(val) {
                            return val[1] / unit;
                        },
                        itemStyle: {
                            normal: {
                                color: '#ddb926'
                            }
                        }
                    },
                    {
                        name: 'Top 12',
                        type: 'effectScatter',
                        coordinateSystem: 'calendar',
                        calendarIndex: 1,
                        data: data.sort(function(a, b) {
                            return b[1] - a[1];
                        }).slice(0, 12),
                        symbolSize: function(val) {
                            return val[1] / unit;
                        },
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        hoverAnimation: true,
                        itemStyle: {
                            normal: {
                                color: '#f4e925',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        zlevel: 1
                    },
                    {
                        name: 'Top 12',
                        type: 'effectScatter',
                        coordinateSystem: 'calendar',
                        data: data.sort(function(a, b) {
                            return b[1] - a[1];
                        }).slice(0, 12),
                        symbolSize: function(val) {
                            return val[1] / unit;
                        },
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        hoverAnimation: true,
                        itemStyle: {
                            normal: {
                                color: '#f4e925',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        },
                        zlevel: 1
                    }
                ]
            })
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/calendar.vue